const LOCAL_STORAGE_KEY = 'converterUsage';

export function getUsageData(): Record<string, number> {
  if (typeof window === 'undefined') {
    return {};
  }
  const data = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Error parsing usage data:', error);
      return {};
    }
  } else {
    return {};
  }
}

export function trackConversion(fromUnit: string, toUnit: string) {
  const usageData = getUsageData();
  const conversionKey = `${fromUnit}-${toUnit}`;
  usageData[conversionKey] = (usageData[conversionKey] || 0) + 1;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(usageData));
  window.dispatchEvent(new Event('storage'));
}
